export default __webpack_public_path__ + "static/map-d1a1d7f38d8b22682d404ac896c98c27.png";